import React from 'react'
import PageTitle from '../components/common/pageTitle'
import { partnersData } from '../utlits/fackData/partnersData'
import PartnersCard from '../components/sections/partnersCard'
import { ScrollRestoration } from 'react-router-dom'
import Title from '../components/common/title'

const Partners = () => {
  return (
    <>
    
      <PageTitle link={"Our Partners"} pageName={"Partners"} />
      <div className="team-area pages-style pt-100 pb-75">
        <div className="container">
          <Title sectionName={""} sectionTitle={"Meet Our Awesome Partners."}/>

          <div className="row">
            {
              partnersData.map(({ id, name, position, social_media, src }) => {
                return (
                  <div key={id} className="col-lg-4 col-sm-6">
                    <PartnersCard id={id} name={name} position={position} social_media={social_media} src={src} style={"team-style"} />
                  </div>
                )
              })
            }
          </div>
        </div>
        <div className="bg-ellipse"></div>
      </div>
      <ScrollRestoration />
    </>
  )
}

export default Partners